import { ChangeDetectorRef, Component, inject, ChangeDetectionStrategy } from '@angular/core';

import type { DialogComponentI } from '@core/user-interface-legacy';
import { DialogRef } from '@core/user-interface-legacy';

import { Step } from '../../security.types';
import { AppActivationStep1Component } from './app-activation-step-1/app-activation-step-1.component';
import { AppActivationStep2Component } from './app-activation-step-2/app-activation-step-2.component';

@Component({
  selector: 'rt-app-activation-dialog',
  templateUrl: './app-activation-dialog.component.html',
  styleUrls: ['./app-activation-dialog.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AppActivationStep1Component, AppActivationStep2Component],
})
export class AppActivationDialogComponent implements DialogComponentI<{}, undefined> {
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly dialogRef = inject(DialogRef);

  public step: Step = Step.One;
  public Step: typeof Step = Step;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setDialogData() {}

  public changeStep(step: Step): void {
    this.step = step;
    this.cdRef.detectChanges();
  }

  public activated(): void {
    this.dialogRef.close();
  }

  public cancel(): void {
    this.dialogRef.close();
  }
}
